import AuthorRoleQueries from '@/graphql/AuthorRoleQueries';

export default {
  data() {
    return {
      authorRoles: [],
      loadingRoles: false
    };
  },
  methods: {
    async fetchAuthorRoles() {
      this.loadingRoles = true;
      try {
        const result = await this.$apollo.query({
          query: AuthorRoleQueries.getAuthorRoles,
          fetchPolicy: 'cache-first'
        });
        
        // Add localized description to each role
        this.authorRoles = result.data.authorRoles.map(role => ({
          ...role,
          localizedDescription: this.getLocalizedRoleDescription(role._id) || role.description
        }));
        
        return this.authorRoles;
      } catch (error) {
        console.error('Error fetching author roles:', error);
        this.$store.dispatch('snackbar/showSnackbar', {
          text: this.$t('admin.errors.fetchAuthorRolesFailed'),
          color: 'error'
        });
        return [];
      } finally {
        this.loadingRoles = false;
      }
    },
    
    getLocalizedRoleDescription(roleId) {
      return this.$t(`authorRoles.${roleId}`, null);
    },
    
    getRoleIdByDescription(description) {
      // Try to find the role by localized description
      const role = this.authorRoles.find(role => role.localizedDescription === description);
      return role ? role._id : 'author'; // Fallback to 'author' if not found
    }
  }
};
